/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketCompletionRequestDto } from './TicketCompletionRequestDto';
import {
    TicketCompletionRequestDtoFromJSON,
    TicketCompletionRequestDtoFromJSONTyped,
    TicketCompletionRequestDtoToJSON,
    TicketCompletionRequestDtoToJSONTyped,
} from './TicketCompletionRequestDto';

/**
 * 
 * @export
 * @interface CompleteWorkOrderRequestDto
 */
export interface CompleteWorkOrderRequestDto {
    /**
     * 
     * @type {Array<TicketCompletionRequestDto>}
     * @memberof CompleteWorkOrderRequestDto
     */
    ticketCompletions: Array<TicketCompletionRequestDto>;
}

/**
 * Check if a given object implements the CompleteWorkOrderRequestDto interface.
 */
export function instanceOfCompleteWorkOrderRequestDto(value: object): value is CompleteWorkOrderRequestDto {
    if (!('ticketCompletions' in value) || value['ticketCompletions'] === undefined) return false;
    return true;
}

export function CompleteWorkOrderRequestDtoFromJSON(json: any): CompleteWorkOrderRequestDto {
    return CompleteWorkOrderRequestDtoFromJSONTyped(json, false);
}

export function CompleteWorkOrderRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteWorkOrderRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ticketCompletions': ((json['ticketCompletions'] as Array<any>).map(TicketCompletionRequestDtoFromJSON)),
    };
}

export function CompleteWorkOrderRequestDtoToJSON(json: any): CompleteWorkOrderRequestDto {
    return CompleteWorkOrderRequestDtoToJSONTyped(json, false);
}

export function CompleteWorkOrderRequestDtoToJSONTyped(value?: CompleteWorkOrderRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ticketCompletions': ((value['ticketCompletions'] as Array<any>).map(TicketCompletionRequestDtoToJSON)),
    };
}

